import { useForm, Controller } from 'react-hook-form'
import { useTypeTaskContext } from '../../../shared/context/typeTaskContext'
import { useUtiles } from '../../../shared/context/utilesContext'
import { Box, Grid, Button, TextField } from '@mui/material'

export default function CreateTypeTaskComponent() {

    const { control, handleSubmit, formState: { errors } } = useForm()

    const { createTypeTask, loadingCreateTypeTask } = useTypeTaskContext()
    const { restorePreviousComponent, setAlertSnackbar } = useUtiles()
    const handleCreateTypeTask = async (data) => {
        try {
            await createTypeTask({...data})
            
            // Mostrar mensaje de éxito
            setAlertSnackbar({
                open: true,
                message: 'Tipo de tarea creada exitosamente',
                severity: 'success'
            })
            
            // Restaurar el componente anterior
            restorePreviousComponent()
        } catch (error) {
            setAlertSnackbar({
                open: true,
                message: error.message || 'Error al crear la clasificación',
                severity: 'error'
            })
        }


    }

    return (
        <Box sx={{
            padding: '10px',
        }}>
            <form onSubmit={handleSubmit(handleCreateTypeTask)}>
                <Grid container spacing={2}>
                    <Grid item size={{ xs: 12, }}>
                    <Controller
                        control={control}
                        name="value"
                        rules={{ required: 'Este campo es requerido' }}
                        render={({ field }) => (
                            <TextField fullWidth placeholder="Nombre" {...field} error={!!errors.value} helperText={errors.value?.message} />
                        )}
                    />
                </Grid>
                <Grid item size={{ xs: 12}}>
                        <Button type="submit" variant="contained" color="primary">Crear</Button>
                        <Button 
                            variant="contained" 
                            color="disabled" 
                            sx={{ ml: 1 }}
                            onClick={restorePreviousComponent}
                        >
                            Cancelar
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Box>
    )
}